import * as Yup from "yup";
import React, { useState } from "react";
import { errorToast, successToast } from "../Toast";
import { Field, Form, Formik, ErrorMessage } from "formik";
import { createPackingTypeApi } from "../../services/_packingTypes";

const createPackingTypeInitialValues = {
  name: "",
  weight: "",
  description: "",
  status: "",
};

interface AddPackingTypeModalProps {
  addPackingTypeModalStatus: boolean;
  closePackingTypeModal: () => void;
  onPackingTypeCreated: any;
}

const createPackingTypeValidationSchema = Yup.object().shape({
  name: Yup.string().required("PackingType is required"),
  weight: Yup.number()
    .moreThan(0, "weight must be greater than 0")
    .required("Weight is required"),
  description: Yup.string(),
  status: Yup.string().required("Status is required"),
});

const AddPackingType: React.FC<AddPackingTypeModalProps> = ({
  addPackingTypeModalStatus,
  closePackingTypeModal,
  onPackingTypeCreated,
}) => {
  const [submitLoader, setSubmitLoader] = useState(false);

  const handleSubmit = async (values: any, { resetForm }: any) => {
    setSubmitLoader(true);
    const updatedValues = {
      ...values,
      status: values.status === "true",
      name: values.name.toUpperCase(),
    };
    try {
      const result: any = await createPackingTypeApi(updatedValues);

      if (result.isSuccess) {
        setSubmitLoader(false);
        resetForm({ values: createPackingTypeInitialValues });
        successToast(result.message);
        closePackingTypeModal();
        onPackingTypeCreated();
      } else {
        errorToast(result.message);
        setSubmitLoader(false);
      }
    } catch (error) {
      errorToast("An error occurred while creating the unit");
    }
    setSubmitLoader(false);
  };

  return (
    <>
      {addPackingTypeModalStatus && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div
            className="modal fade show"
            id="PackingTypeModal"
            tabIndex={-3}
            aria-hidden={!addPackingTypeModalStatus}
            style={{ display: addPackingTypeModalStatus ? "block" : "none" }}
          >
            <div className="modal-dialog modal-lg modal-simple modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body p-4">
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={closePackingTypeModal}
                  ></button>
                  <div className="text-center mb-2">
                    <h4 className="mb-2">Add Packing Type</h4>
                  </div>
                  <div className="modal-body p-0">
                    <Formik
                      validationSchema={createPackingTypeValidationSchema}
                      initialValues={createPackingTypeInitialValues}
                      onSubmit={handleSubmit}
                    >
                      {({ handleChange, values }) => (
                        <Form className="row g-4">
                          <div className="col-12 col-md-6">
                            <label htmlFor="name" className="form-label">
                              Name <span className="text-danger">*</span>
                            </label>
                            <Field
                              id="name"
                              name="name"
                              type="text"
                              className="form-control"
                              placeholder="Enter name"
                              onChange={handleChange}
                            />
                            <ErrorMessage
                              name="name"
                              className="text-danger"
                              component="div"
                            />
                          </div>
                          <div className="col-12 col-md-6">
                            <label
                              htmlFor="weight"
                              className="form-label"
                              style={{ fontSize: "0.9375rem" }}
                            >
                              Weight: <span className="text-danger">*</span>
                            </label>
                            <Field
                              id="weight"
                              name="weight"
                              type="number"
                              className="form-control"
                              placeholder="Enter weight"
                              onChange={handleChange}
                            />
                            <ErrorMessage
                              name="weight"
                              className="text-danger"
                              component="div"
                            />
                          </div>
                          <div className="col-12 col-sm-6 ">
                            <label
                              htmlFor="status"
                              className="form-label"
                              style={{ fontSize: "0.9375rem" }}
                            >
                              Status: <span className="text-danger">*</span>
                            </label>
                            <select
                              id="status"
                              name="status"
                              className="form-select"
                              value={values.status}
                              onChange={handleChange}
                            >
                              <option value="">Select Status</option>
                              <option value="true">Active</option>
                              <option value="false">Inactive</option>
                            </select>
                            <ErrorMessage
                              name="status"
                              className="text-danger"
                              component="div"
                            />
                          </div>
                          <div className="mb-3">
                            <label htmlFor="description" className="form-label">
                              Description
                            </label>
                            <Field
                              id="description"
                              name="description"
                              type="text"
                              className="form-control"
                              placeholder="Enter description"
                              onChange={handleChange}
                            />
                            <ErrorMessage
                              name="description"
                              className="text-danger"
                              component="div"
                            />
                          </div>

                          <div className="col-12 text-center mt-4">
                            <button
                              type="submit"
                              className="btn btn-primary me-3"
                              disabled={submitLoader}
                            >
                              {submitLoader && (
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              )}{" "}
                              Add Packing Type
                            </button>
                            <button
                              type="button"
                              className="btn btn-label-secondary"
                              onClick={closePackingTypeModal}
                            >
                              Cancel
                            </button>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AddPackingType;
